import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { TextConfigurationItem } from './types-store';
import { TextConfigurationItemWire } from './types';

export const mapTextItemFromWire = (textItem: TextConfigurationItemWire): TextConfigurationItem => {
  return {
    id: textItem.id,
    textSet: codeItemToStoreValue(textItem.textSet || { v: undefined }),
    textCollection: (textItem.textCollection || []).map(codeItemToStoreValue),
    translations: textItem.translations
  };
};

export const mapTextItemToWire = (textItem: TextConfigurationItem): TextConfigurationItemWire => {
  return {
    ...(isDefinedIncludingZero(textItem && textItem.id) && { id: textItem.id }),
    ...(isDefinedIncludingZero(textItem && textItem.textSet && textItem.textSet.value) && {
      textSet: { v: textItem.textSet.value }
    }),
    textCollection: (textItem.textCollection || []).map(tc => ({ v: tc.value })),
    translations: textItem.translations || []
  };
};
